import { passwordArray, Passwordpattern } from "../patterns/Pattern";

export const ChangePasswordValid = (name, value, nPassword, cPassword) => {
  let error = "";
  if (name === "newPassword") {
    if (value === "") {
      error = "This field is required.";
      return { name: "newPassword", error: error };
    }
    if (!Passwordpattern.test(value)) {
      error =
        "Password must be minimum 8 characters long and maximum 16 character long, contain at least one upper case letter, one lower case letter, one number, and one special character.";
      return { name: "newPassword", error: error };
    }
    const isReservedPassword = passwordArray.some((reserved) =>
      value.toLowerCase().includes(reserved.toLowerCase())
    );
    if (isReservedPassword) {
      return {
        name: "newPassword",
        error: "Password is too common. Please choose a more secure password.",
      };
    }
    if (cPassword !== "") {
      if (value !== cPassword) {
        error = "Confirm password does't matched.";
        return [
          { name: "newPassword", error: "" },
          { name: "confirmPassword", error: error },
        ];
      } else {
        return [
          { name: "newPassword", error: error },
          { name: "confirmPassword", error: error },
        ];
      }
    }
    return { name: "newPassword", error: error };
  }
  if (name === "confirmPassword") {
    if (value === "") {
      error = "This field is required.";
      return { name: "confirmPassword", error: error };
    }
    if (nPassword !== "") {
      if (nPassword !== value) {
        error = "Confirm password does't matched.";

        return { name: "confirmPassword", error: error };
      }
    }
    return { name: "confirmPassword", error: error };
  }

  if (name === "currentPassword") {
    if (value === "") {
      error = "This field is required.";
      return { name: "currentPassword", error: error };
    }

    return { name: "currentPassword", error: error };
  } else {
    return { name: name, error: error };
  }
};
